/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/plan-timeline-skeleton.tpl.svg';
import withoutFiltersSVG from './assets/plan-timeline-without-filters-skeleton.tpl.svg';

const customCssStyles = css({
	// increase self specificity to ensure deterministic override
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		border: 'none',
	},
});

const customCssStylesWithPadding = css({
	// increase self specificity to ensure deterministic override
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		borderLeftWidth: '24px',
		borderRightWidth: '0',
	},
});

export const PlanTimelineSkeleton = (): JSX.Element => (
	<AppSkeletonImage src={imgSVG} css={customCssStylesWithPadding} />
);

export const PlanTimelineSkeletonWithoutPadding = (): JSX.Element => (
	<AppSkeletonImage src={imgSVG} css={customCssStyles} />
);

export const PlanTimelineSkeletonWithoutFilters = (): JSX.Element => (
	<AppSkeletonImage src={withoutFiltersSVG} css={customCssStyles} />
);
